"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageReciprocateEffectHandler = exports.DamageReciprocateEffectArgs = void 0;
const __1 = require("../../..");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class DamageReciprocateEffectArgs {
    constructor(damage) {
        this.damage = damage;
        this.__type = EffectType_1.EffectType.DamageReciprocate;
        this.__typeName = "DamageReciprocate";
        this.name = "Damage Reciprocation";
        this.harmful = false;
    }
}
exports.DamageReciprocateEffectArgs = DamageReciprocateEffectArgs;
let DamageReciprocateEffectHandler = class DamageReciprocateEffectHandler {
    apply(sequence, container, state) {
        const scriptArgs = {
            damageToReciprocate: state.args.damage
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.targetId, EventType_1.EventType.Attacked, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_DamageReciprocation", scriptArgs));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
DamageReciprocateEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.DamageReciprocate)
], DamageReciprocateEffectHandler);
exports.DamageReciprocateEffectHandler = DamageReciprocateEffectHandler;
